// extracted by mini-css-extract-plugin
export var footer = "_nl-0";
export var inherit = "_nl-1";
export var input = "_nl-2";
export var modalContent = "_nl-3";
export var quillEditor = "_nl-4";
export var subtitle = "_nl-5";